mutation ChartOfAccountDefaultUpdate(
  $input: ChartOfAccountDefaultUpdateInput!
) {
  chartOfAccountDefaultUpdate(input: $input) {
    _isDefaultSet
  }
}
